import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
    createDashboardConfig,
    deleteDashboardConfig,
    getDashboardConfig,
    updateDashboardConfig,
} from '../../../../api/admin-dashboard-config.api'
import { DashboardConfig } from '../types/dashboard.type'

export const useDashboardConfig = () => {
    const queryClient = useQueryClient()

    const {
        data: config,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['dashboard-config'],
        queryFn: getDashboardConfig,
    })

    const createMutation = useMutation({
        mutationFn: (config: DashboardConfig) => createDashboardConfig(config),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['dashboard-config'] })
        },
    })

    const updateMutation = useMutation({
        mutationFn: (config: DashboardConfig) => updateDashboardConfig(config),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['dashboard-config'] })
        },
    })

    const deleteMutation = useMutation({
        mutationFn: () => deleteDashboardConfig(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['dashboard-config'] })
        },
    })

    return {
        config,
        isLoading,
        error,
        createConfig: createMutation.mutate,
        updateConfig: updateMutation.mutate,
        deleteConfig: deleteMutation.mutate,
        isCreating: createMutation.isPending,
        isUpdating: updateMutation.isPending,
        isDeleting: deleteMutation.isPending,
    }
}
